/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-template */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { ToggleButton } from 'primereact/togglebutton';
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { orderBy } from 'lodash';
import { displayErrors } from '../../../util/diversos';
import Card from '../../../components/card';

import axiosCoto from '../../../services/axiosCoto';
import IconButton from '../../../components/IconButton';

import { Input155px, Input250px } from '../../../styles/inputGroup';

import Loading from '../../loading';

export default function RelatorioPedido() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const idUsuario = useSelector((state) => state.auth.user.id);

  let descricaoPedido = '';
  let dataFechamento = '';

  const [pedido, setPedido] = useState();
  const [vendedor, setVendedor] = useState();
  // eslint-disable-next-line no-unused-vars
  const [totalPedido, setTotalPedido] = useState(0);
  const [mostrarProdutosZerados, setMostrarProdutosZerados] = useState(false);

  const [listaPedidos, setListaPedidos] = useState([]);
  const [listaVendedores, setListaVendedores] = useState([]);

  const [listaPastas, setListaPastas] = useState([]);
  const [pastaSelecionada, setPastaSelecionada] = useState(0);
  const [filteredPasta, setFilteredPasta] = useState(0);

  function headRows() {
    return [
      { numItemPedido: 'Item', Pedido: 'Pedido', Produto: 'Produto / Vendedor', Caixa: 'Valor Caixa ', Qtde: 'Qtde Por CX', UN: 'Valor UN', Total: 'Total' },
    ];
  }

  function headRowsICMSIPI() {
    return [
      { numItemPedido: 'Item', Pedido: 'Pedido', Produto: 'Produto / Vendedor', Caixa: 'Valor Caixa ', Qtde: 'Qtde Por CX', UN: 'Valor UN', Total: 'Total', percentualICMS: 'Perc. ICMS', percentualIPI: 'Perc. IPI' },
    ];
  }
  const [headerTabelaImpressao, setHeaderTabelaImpressao] = useState(headRows());

  async function getPastas(idVendedor) {
    const listDropdown = [];
    try {
      setIsLoading(true);

      const { data: _pastas } = await axiosCoto.get(`/pasta/?idVendedor=${idVendedor}`);

      if (_pastas.length > 0) {
        _pastas.forEach(element => {
          listDropdown.push({ label: element.descricao, value: element.id });
        });
      }

      setListaPastas(listDropdown);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  const searchPasta = (event) => {
    setPastaSelecionada(event.query);

    const listDropdown = [];
    listaPastas.forEach(element => {
      if (element.label.toLowerCase().startsWith(event.query.toLowerCase())) {
        listDropdown.push({ label: element.label, value: element.value });
      }
    });

    setFilteredPasta(listDropdown);
  };

  // eslint-disable-next-line consistent-return
  async function getData() {
    // eslint-disable-next-line new-cap
    const doc = new jsPDF();
    try {
      setIsLoading(true);

      // pega os campos da busca
      const id = pedido;
      let idVendedor = vendedor;
      let nomeVendedor = 'Todos';
      let pagamentoPrazo = '';
      let diasEntrega = '';
      let tipoEntrega = '';
      let diasETipoEntrega = '';

      const result = [];

      if (!idVendedor) idVendedor = 0;
      if (id > 0 && idVendedor >= 0) {
        let contador = 1;
        let totalPedido = 0;

        let dataProduto = {
          id: '0',
          Pedido: '0',
          QtdeAtacado: 0,
          ValorAtacado: 0,
          Produto: '',
          Caixa: '',
          Qtde: '0',
          UN: '0',
          Total: '0',
          percentualICMS: '',
          percentualIPI: '',
        };

        let data = {
          id: '0',
          Pedido: '0',
          QtdeAtacado: 0,
          ValorAtacado: 0,
          Produto: '',
          Caixa: '',
          Qtde: '0',
          UN: '0',
          Total: '0',
          percentualICMS: '',
          percentualIPI: '',
        };

        if (idVendedor > 0) {
          const { data: _pedido } = await axiosCoto.get(`/pedido/pedidopararelatoriocompradorcomvendedordto/${id}/${idVendedor}`);

          if (_pedido.length <= 0) {
            toast.info('Vendedor não possue produtos para essa cotação.');
            return false;
          }

          dataFechamento = `${('00' + _pedido[0].data[2]).slice(-2)}/${('00' + _pedido[0].data[1]).slice(-2)}/${_pedido[0].data[0]}`;

          pagamentoPrazo = '';
          if (_pedido[0].pagamentoPrazo) {
            pagamentoPrazo = _pedido[0].pagamentoPrazo;
          }

          diasEntrega = '';
          if (_pedido[0].diasentrega) {
            diasEntrega = _pedido[0].diasentrega;
            diasETipoEntrega = _pedido[0].diasentrega;
          }

          tipoEntrega = '';
          if (_pedido[0].tipoEntrega) {
            tipoEntrega = _pedido[0].tipoEntrega;
            if (diasEntrega) {
              diasETipoEntrega += `/ ${tipoEntrega}`;
            } else {
              diasETipoEntrega = `${tipoEntrega}`;
            }
          }

          nomeVendedor = 'Todos';
          if (_pedido[0].razaoSocial) {
            nomeVendedor = _pedido[0].razaoSocial;
          }

          descricaoPedido = _pedido[0].descricao;

          for (let x = 0; x < _pedido.length; x++) {
            const pedido = _pedido[x];

            pedido.pedidoProdutos.qtdeRespostas = pedido.pedidoProdutos.pedidoProdutoRespostas.length;

            for (let i = 0; i < pedido.pedidoProdutos.pedidoProdutoRespostas.length; i++) {
              const produtoResposta = pedido.pedidoProdutos.pedidoProdutoRespostas[i];
              // console.log('produtoResposta: ', produtoResposta );
              let valorTotalCompra = 0;
              let qtdeTotalcompra = 0;
              if (produtoResposta && pastaSelecionada === null) {
                qtdeTotalcompra += produtoResposta.qtdePedido ? +produtoResposta.qtdePedido : 0;

                if (+produtoResposta.qtdePedido >= +produtoResposta.qtdeAtacado && +produtoResposta.qtdeAtacado > 0) {
                  valorTotalCompra += (+produtoResposta.valorAtacado * +produtoResposta.qtdePedido);
                } else {
                  valorTotalCompra += +produtoResposta.qtdePedido * +produtoResposta.valorCaixa;
                }

                pedido.pedidoProdutos.qtdeTotalCompra = qtdeTotalcompra;
                pedido.pedidoProdutos.valorTotalCompra = valorTotalCompra;

                let valorCompra = 0;
                if (+produtoResposta.qtdePedido > 0 || mostrarProdutosZerados) {
                  // preenche o data cabecalho do produto uma vez
                  data.numItemPedido = contador.toString();
                  data.Produto = pedido.pedidoProdutos.codigoEan ? `${pedido.pedidoProdutos.codigoEan} - ${pedido.pedidoProdutos.descricaoProduto.toString().toUpperCase()}` : pedido.pedidoProdutos.descricaoProduto.toString().toUpperCase();
                  data.Caixa = produtoResposta.valorCaixa.toFixed(2).toString();
                  data.Qtde = produtoResposta.qtdePorCaixa.toString();
                  data.UN = produtoResposta.valorUnitario.toFixed(3).toString();
                  data.Pedido = produtoResposta.qtdePedido.toString();

                  if (produtoResposta.qtdeAtacado === null) {
                    data.QtdeAtacado = '0';
                  } else {
                    data.QtdeAtacado = produtoResposta.qtdeAtacado.toString();
                  }

                  if (produtoResposta.valorAtacado === null) {
                    data.ValorAtacado = '0';
                  } else {
                    data.ValorAtacado = produtoResposta.valorAtacado.toFixed(2).toString();
                  }

                  if (parseFloat(data.Pedido) >= parseFloat(data.QtdeAtacado) && parseFloat(data.QtdeAtacado) > 0) {
                    data.Caixa = data.ValorAtacado;
                    data.UN = (parseFloat(data.ValorAtacado).toFixed(2) / parseFloat(data.Qtde).toFixed(2));
                    valorCompra = (parseFloat(data.ValorAtacado).toFixed(2) * parseFloat(data.Pedido).toFixed(2));
                  } else {
                    valorCompra = (parseFloat(data.Caixa).toFixed(2) * parseFloat(data.Pedido).toFixed(2));
                  }
                  data.Caixa = `R$ ${data.Caixa.replace('.', ',')}`;
                  data.Total = `R$ ${valorCompra.toFixed(2).replace('.', ',').toString()}`;
                  data.UN = `R$ ${parseFloat(data.UN).toFixed(3).replace('.', ',').toString()}`;
                  totalPedido += valorCompra;

                  if (produtoResposta.percentualICMS === null) {
                    data.percentualICMS = '0';
                  } else {
                    data.percentualICMS = produtoResposta.percentualICMS.toString();
                  }
                  if (produtoResposta.percentualIPI === null) {
                    data.percentualIPI = '0';
                  } else {
                    data.percentualIPI = produtoResposta.percentualIPI.toString();
                  }

                  if (parseFloat(data.percentualICMS) > 0 || parseFloat(data.percentualIPI) > 0) {
                    setHeaderTabelaImpressao(headRowsICMSIPI);
                  }

                  result.push({ ...data });

                  contador++;
                }
              } else if (produtoResposta && produtoResposta.pasta !== null && produtoResposta.pasta === pastaSelecionada.label) {
                qtdeTotalcompra += produtoResposta.qtdePedido ? +produtoResposta.qtdePedido : 0;

                if (+produtoResposta.qtdePedido >= +produtoResposta.qtdeAtacado && +produtoResposta.qtdeAtacado > 0) {
                  valorTotalCompra += (+produtoResposta.valorAtacado * +produtoResposta.qtdePedido);
                } else {
                  valorTotalCompra += +produtoResposta.qtdePedido * +produtoResposta.valorCaixa;
                }

                pedido.pedidoProdutos.qtdeTotalCompra = qtdeTotalcompra;
                pedido.pedidoProdutos.valorTotalCompra = valorTotalCompra;

                let valorCompra = 0;
                if (+produtoResposta.qtdePedido > 0 || mostrarProdutosZerados) {
                  // preenche o data cabecalho do produto uma vez
                  data.numItemPedido = contador.toString();
                  data.Produto = pedido.pedidoProdutos.codigoEan ? `${pedido.pedidoProdutos.codigoEan} - ${pedido.pedidoProdutos.descricaoProduto.toString().toUpperCase()}` : pedido.pedidoProdutos.descricaoProduto.toString().toUpperCase();
                  data.Caixa = produtoResposta.valorCaixa.toFixed(2).toString();
                  data.Qtde = produtoResposta.qtdePorCaixa.toString();
                  data.UN = produtoResposta.valorUnitario.toFixed(3).toString();
                  data.Pedido = produtoResposta.qtdePedido.toString();

                  if (produtoResposta.qtdeAtacado === null) {
                    data.QtdeAtacado = '0';
                  } else {
                    data.QtdeAtacado = produtoResposta.qtdeAtacado.toString();
                  }

                  if (produtoResposta.valorAtacado === null) {
                    data.ValorAtacado = '0';
                  } else {
                    data.ValorAtacado = produtoResposta.valorAtacado.toFixed(2).toString();
                  }

                  if (parseFloat(data.Pedido) >= parseFloat(data.QtdeAtacado) && parseFloat(data.QtdeAtacado) > 0) {
                    data.Caixa = data.ValorAtacado;
                    data.UN = (parseFloat(data.ValorAtacado).toFixed(2) / parseFloat(data.Qtde).toFixed(2));
                    valorCompra = (parseFloat(data.ValorAtacado).toFixed(2) * parseFloat(data.Pedido).toFixed(2));
                  } else {
                    valorCompra = (parseFloat(data.Caixa).toFixed(2) * parseFloat(data.Pedido).toFixed(2));
                  }
                  data.Caixa = `R$ ${data.Caixa.replace('.', ',')}`;
                  data.Total = `R$ ${valorCompra.toFixed(2).replace('.', ',').toString()}`;
                  data.UN = `R$ ${parseFloat(data.UN).toFixed(3).replace('.', ',').toString()}`;
                  totalPedido += valorCompra;

                  if (produtoResposta.percentualICMS === null) {
                    data.percentualICMS = '0';
                  } else {
                    data.percentualICMS = produtoResposta.percentualICMS.toString();
                  }
                  if (produtoResposta.percentualIPI === null) {
                    data.percentualIPI = '0';
                  } else {
                    data.percentualIPI = produtoResposta.percentualIPI.toString();
                  }

                  if (parseFloat(data.percentualICMS) > 0 || parseFloat(data.percentualIPI) > 0) {
                    setHeaderTabelaImpressao(headRowsICMSIPI);
                  }

                  result.push({ ...data });

                  contador++;
                }
              }
            }
          }

          // eslint-disable-next-line no-shadow

          setHeaderTabelaImpressao(headRows());
        } else { // vendedor nao selecionado
          const { data: _pedido } = await axiosCoto.get(`/pedido/pedidopararelatoriocompradordto/${id}`);

          // console.log('_pedido: ', _pedido);

          descricaoPedido = _pedido[0].descricao;
          dataFechamento = `${('00' + _pedido[0].data[2]).slice(-2)}/${('00' + _pedido[0].data[1]).slice(-2)}/${_pedido[0].data[0]}`;

          for (let x = 0; x < _pedido.length; x++) {
            const pedido = _pedido[x];

            let cabecalhoPreenchido = false;
            pedido.pedidoProdutos.qtdeRespostas = pedido.pedidoProdutos.pedidoProdutoRespostas.length;

            // somar valor da compra
            let valorTotalCompra = 0;
            let qtdeTotalcompra = 0;
            for (let i = 0; i < pedido.pedidoProdutos.pedidoProdutoRespostas.length; i++) {
              const produtoResposta = pedido.pedidoProdutos.pedidoProdutoRespostas[i];
              // console.log('produtoResposta: ', produtoResposta );
              if (produtoResposta) {
                qtdeTotalcompra += produtoResposta.qtdePedido ? +produtoResposta.qtdePedido : 0;

                if (+produtoResposta.qtdePedido >= +produtoResposta.qtdeAtacado && +produtoResposta.qtdeAtacado > 0) {
                  valorTotalCompra += (+produtoResposta.valorAtacado * +produtoResposta.qtdePedido);
                } else {
                  valorTotalCompra += +produtoResposta.qtdePedido * +produtoResposta.valorCaixa;
                }

                pedido.pedidoProdutos.qtdeTotalCompra = qtdeTotalcompra;
                pedido.pedidoProdutos.valorTotalCompra = valorTotalCompra;

                let valorCompra = 0;
                if (+produtoResposta.qtdePedido > 0 || mostrarProdutosZerados) {
                  // preenche o data cabecalho do produto uma vez
                  if (!cabecalhoPreenchido) {
                    dataProduto.numItemPedido = contador.toString();
                    dataProduto.Produto = pedido.pedidoProdutos.codigoEan ? `${pedido.pedidoProdutos.codigoEan} - ${pedido.pedidoProdutos.descricaoProduto.toString().toUpperCase()}` : pedido.pedidoProdutos.descricaoProduto.toString().toUpperCase();
                    dataProduto.Pedido = '';
                    dataProduto.Total = '';
                    dataProduto.Caixa = '';
                    dataProduto.Qtde = '';
                    dataProduto.UN = '';

                    result.push({ ...dataProduto });
                    cabecalhoPreenchido = true;
                    contador++;
                  }

                  // preenche as respostas quantas vezes forem necessarias
                  data.numItemPedido = '';
                  data.Produto = produtoResposta.razaoSocial;
                  data.Caixa = produtoResposta.valorCaixa.toFixed(2).toString();
                  data.Qtde = produtoResposta.qtdePorCaixa.toString();
                  data.UN = produtoResposta.valorUnitario.toFixed(3).toString();
                  data.Pedido = produtoResposta.qtdePedido.toString();

                  if (produtoResposta.qtdeAtacado === null) {
                    data.QtdeAtacado = '0';
                  } else {
                    data.QtdeAtacado = produtoResposta.qtdeAtacado.toString();
                  }

                  if (produtoResposta.valorAtacado === null) {
                    data.ValorAtacado = '0';
                  } else {
                    data.ValorAtacado = produtoResposta.valorAtacado.toFixed(2).toString();
                  }

                  if (parseFloat(data.Pedido) >= parseFloat(data.QtdeAtacado) && parseFloat(data.QtdeAtacado) > 0) {
                    data.Caixa = data.ValorAtacado;
                    data.UN = (parseFloat(data.ValorAtacado).toFixed(2) / parseFloat(data.Qtde).toFixed(2));
                    valorCompra = (parseFloat(data.ValorAtacado).toFixed(2) * parseFloat(data.Pedido).toFixed(2));
                  } else {
                    valorCompra = (parseFloat(data.Caixa).toFixed(2) * parseFloat(data.Pedido).toFixed(2));
                  }
                  data.Caixa = `R$ ${data.Caixa.replace('.', ',')}`;
                  data.Total = `R$ ${valorCompra.toFixed(2).replace('.', ',').toString()}`;
                  data.UN = `R$ ${parseFloat(data.UN).toFixed(3).replace('.', ',').toString()}`;
                  totalPedido += valorCompra;

                  if (produtoResposta.percentualICMS === null) {
                    data.percentualICMS = '0';
                  } else {
                    data.percentualICMS = produtoResposta.percentualICMS.toString();
                  }
                  if (produtoResposta.percentualIPI === null) {
                    data.percentualIPI = '0';
                  } else {
                    data.percentualIPI = produtoResposta.percentualIPI.toString();
                  }

                  if (parseFloat(data.percentualICMS) > 0 || parseFloat(data.percentualIPI) > 0) {
                    setHeaderTabelaImpressao(headRowsICMSIPI);
                  }

                  result.push({ ...data });
                }
              }
            }
          }
        }

        // console.log('result: ', result);

        // linha em branco entre produtos
        data = {
          id: '',
          Produto: '',
          Caixa: '',
          Qtde: '',
          UN: '',
          Pedido: '',
          ValorAtacado: '',
          QtdeAtacado: '',
          Total: '',
          percentualICMS: '',
          percentualIPI: '',
        };

        setTotalPedido(totalPedido);
        data.UN = 'Total';
        data.Total = `R$ ${totalPedido.toFixed(2).replace('.', ',').toString()}`;
        result.push({ ...data });

        doc.autoTable(
          {
            styles: { fontSize: 8 },
            margin: { top: 38, left: 5, right: 5 },
            theme: 'grid',
            head: headerTabelaImpressao,
            body: result,
            // eslint-disable-next-line object-shorthand
            didParseCell: function (HookData) {
              if (HookData.row.cells.Qtde.text[0] === '') {
                HookData.cell.styles.fillColor = '#f4f0ec';
              }
            },
            didDrawPage: (dados) => {
              // Header
              doc.rect(5, 5, 200, 30); //  header
              doc.addImage('logo.png', 'JPEG', 10, 12, 25, 15);
              doc.setFontSize(20);
              doc.text('Relatório de Pedido', 75, 13);

              doc.setFontSize(10);
              doc.text('Número: ', 164, 12);
              doc.text(pedido.toString(), 180, 12);

              doc.text('Descrição:', 45, 18);
              doc.text(descricaoPedido, 63, 18);
              doc.text('Vendedor:', 45, 22);
              doc.text(nomeVendedor, 63, 22);
              if (idVendedor > 0) {
                doc.text('Forma de Pagamento:', 45, 26);
                doc.text(pagamentoPrazo, 82, 26);
              }
              if (idVendedor > 0) {
                doc.text('Dias Entrega / Tipo Entrega:', 45, 30);
                doc.text(diasETipoEntrega, 90, 30);
              }
              if (pastaSelecionada) {
                doc.text('Pasta:', 45, 34);
                doc.text(pastaSelecionada.label, 57, 34);
              }

              doc.text('Fechamento:', 164, 34);
              doc.text(dataFechamento, 186, 34);

              const { pageSize } = doc.internal;
              const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
              doc.text(`Pag ${doc.internal.getNumberOfPages()}`, dados.settings.margin.right, pageHeight - 8);
              doc.text('Elo Informática Barbacena', 82, pageHeight - 8);
              const periodo = new Date();
              const mes = periodo.getMonth() + 1;
              doc.text('Impresso: ', 172, pageHeight - 8);
              doc.text((`${('00' + periodo.getDate()).slice(-2)}/${('00' + mes).slice(-2)}/${periodo.getFullYear()}`).toString(), 189, pageHeight - 8);
            },
          },
        );
        window.open(doc.output('bloburl'));
      } else {
        toast.warning('Nenhuma informação para o relatório.');
      }
    } catch (err) {
      console.log('err: ', err);
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (vendedor > 0) {
      setPastaSelecionada(null);
      getPastas(vendedor);
    } else {
      setListaPastas([]);
      setPastaSelecionada(null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendedor]);

  useEffect(() => {
    async function getPedidos() {
      try {
        setIsLoading(true);
        const listDropdown = [];

        const { data: _pedidos } = await axiosCoto.get(`/pedido/?idUsuario=${idUsuario}&resumida=true`);

        _pedidos.forEach(element => {
          const dia = ('00' + element.data[2]).slice(-2);
          const mes = ('00' + element.data[1]).slice(-2);
          const data = (`${dia}/${mes}/${element.data[0]}`);
          const labelExibicao = `${element.id} - ${data} - ${element.descricao}`;
          listDropdown.push({ label: labelExibicao, value: element.id });
        });

        const _listDropDown = orderBy(listDropdown, 'value', 'desc');

        setListaPedidos(_listDropDown);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getPedidos();

    async function getVendedores() {
      setIsLoading(true);

      const listDropdown = [{ label: 'Todos', value: '' }];
      const id = pedido;

      try {
        if (id > 0) {
          const { data: _vendedores } = await axiosCoto.get(`/pedidoprodutoresposta/buscarvendedoresdistintos/${id}`);

          _vendedores.forEach(element => {
            const labelVendedor = `${element.razaoSocial} - ${element.email} - ${element.telefone1}`;
            listDropdown.push({ label: labelVendedor, value: element.id });
          });

          setListaVendedores(listDropdown);
        } else {
          setListaVendedores([]);
        }
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getVendedores();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, idUsuario, pedido]);

  const handleFind = () => {
    getData();
  };

  return (
    <>
      <Loading isLoading={isLoading} />
      <Card title="Relatório de Pedidos">
        <div className="row form-elo">
          <div className="col-12">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Pedido
              </Input155px>
              <Dropdown
                autoFocus
                options={listaPedidos}
                value={pedido}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={e => setPedido(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Vendedor
              </Input155px>
              <Dropdown
                options={listaVendedores}
                value={vendedor}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={e => setVendedor(e.target.value)}
              />
            </div>
          </div>
          { listaPastas.length > 0 ? (
            <div className="col-4">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Pasta
                </Input155px>
                <AutoComplete
                  value={pastaSelecionada}
                  minLength={1}
                  maxLength={60}
                  suggestions={filteredPasta}
                  completeMethod={searchPasta}
                  field="label"
                  dropdown
                  forceSelection
                  onChange={(e) => setPastaSelecionada(e.target.value)}
                />
                <Button
                  title="Limpar pasta selecionada"
                  icon="pi pi-trash"
                  className="p-button-secondary"
                  onClick={() => setPastaSelecionada(null)}
                />
              </div>
            </div>
          ) : (
            <div className="col-4">
            </div>
          )}
          <div className="col-4">
            <div className="p-inputgroup">
              <Input250px className="p-inputgroup-addon">
                Mostrar produtos sem pedido
              </Input250px>
              <ToggleButton
                onLabel="Sim"
                offLabel="Não"
                onIcon="pi pi-check"
                offIcon="pi pi-times"
                checked={mostrarProdutosZerados}
                onChange={(e) => setMostrarProdutosZerados(e.value)}
              />
              &nbsp; &nbsp;
              <IconButton titulo="imprimir" title="Gerar Relatório" btnStyle="primary" onClick={handleFind} icon="print" />
            </div>
          </div>
        </div>
        <div className="row form-elo">
        </div>
      </Card>
    </>
  );
}
